/** Focus-session lengths offered, in minutes. */
export const FOCUS_LENGTHS = [15, 25, 45] as const;
/** A session stopped early still counts from this many whole minutes. */
export const MIN_LOGGED_MINUTES = 1;

/** "24:05" for a number of milliseconds left (never negative). */
export function formatClock(msLeft: number): string {
  const total = Math.max(0, Math.ceil(msLeft / 1000));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

/** Whole minutes focused so far, from the session length and the time left. */
export function minutesFocused(lengthMinutes: number, msLeft: number): number {
  return Math.max(0, Math.min(lengthMinutes, Math.floor((lengthMinutes * 60_000 - Math.max(0, msLeft)) / 60_000)));
}
